import Image from "next/image";
import { FC } from "react";

type Props = {};

const EmailBlock: FC<Props> = () => {
	return (
		<div className='border-[2px] border-white w-[821px]  mx-auto mt-[69px] max-desktop:mt-[50px] flex flex-col items-center py-[45px] max-desktop:py-[32px] rounded-[15px] max-desktop:w-[575px] max-tablet:w-full'>
			<Image
				width={53}
				height={42}
				src={"/icons/mail.svg"}
				alt='Mail Icon'
				className='max-desktop:w-[33px] max-desktop:h-[23px]'
			/>
			<p className='text-center font-bold text-[27px] mt-[31px] max-desktop:mt-[20px] max-desktop:text-[18px]'>
				support@wbtbridge.com
			</p>
			<p className='text-center opacity-85 text-[27px] mt-[15px] max-desktop:mt-[4px] max-desktop:text-[18px]'>
				The best way to get answer faster.
			</p>
		</div>
	);
};

export default EmailBlock;
